<template>
</template>

<script>
import {routePath} from '@/main.js'

export default {
  name: 'Home',
  components: {
  },
  data: function () {
    return {
    }
  },
  mounted: function () {
    this.$router.push('/' + routePath)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue